
import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FEATURED_PRODUCTS } from "@/data/products";

// Get unique categories from products
const categories = Array.from(
  new Set(FEATURED_PRODUCTS.map((product) => product.category))
);

interface FilterPillsProps {
  selectedCategory: string | null;
  setSelectedCategory: (category: string | null) => void;
}

export function FilterPills({
  selectedCategory,
  setSelectedCategory,
}: FilterPillsProps) {
  if (!selectedCategory) return null;

  return (
    <div className="inline-flex ml-2">
      <Badge 
        variant="outline" 
        className="flex items-center gap-1 py-1 px-2 bg-secondary/50"
      >
        {selectedCategory}
        <X 
          className="h-3 w-3 cursor-pointer hover:text-destructive" 
          onClick={() => setSelectedCategory(null)}
          aria-label="Clear filter"
        />
      </Badge>
    </div>
  );
}
